import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';

interface OADatePopupProps {
  value: any;
  onChange: any;
  endDate?: any;
  startDate?: any;
  dateFormat: string;
  label: string;
  sx?: any;
  error?: boolean;
  helperText?: string;
  onBlur?: any;
  orgCode?: string;
}

const OADatePopup = ({
  value,
  onChange,
  endDate,
  startDate,
  label,
  dateFormat = 'dd/MM/yyyy',
  sx,
  error = false,
  helperText = '',
  onBlur,
  orgCode
}: OADatePopupProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MobileDatePicker
        label={label}
        maxDate={endDate}
        minDate={startDate}
        format={dateFormat}
        sx={sx}
        value={value}
        onChange={onChange}
        slotProps={{ textField: { variant: orgCode === 'ZOLVE' ? 'outlined' : 'filled', error, helperText, onBlur } }}
      />
    </LocalizationProvider>
  );
};

export default OADatePopup;
